/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-21 10:43:07
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-01 11:25:32
 * @FilePath: \mpc-monorepo\features\mpc-common\src\utils\openDetail.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

const DetailPathMap = {
  // 渠道需求类型
  'CHANNEL_GROUP': '/channelDistributionWorkbench/channelDistributionGroup/projectDetailSingle/',
  // 市场需求类型
  'MARKET_GROUP': '/marketWorkbench/marketGroup/projectDetailSingle/',
  // 渠道小喇叭需求类型
  'cd_trumpet_group': '/channelDistributionWorkbench/channelDistributionTrumpet?projectId=',
  // 比选类型
  'bidding': '/bidding?projectId=',
  // 营销闭环
  'm_closed_loop': '/myWorkBench/myWorkBenchMarketingClosedLoop/all?projectId=',
} as const;


type DetailType = keyof typeof DetailPathMap

export function getDetailPath(type: DetailType, id: string) {
  return DetailPathMap[type] + id
}


export function openDetailPath(type: DetailType, id: string) {
  const targetPath = location.origin + '/#' + getDetailPath(type, id)
  window.open(targetPath, '_blank')
}
